import Script from 'next/script'

import { useRouterExtend } from 'hooks/useRouterExtend'
import { LOCALE } from 'interfaces/types'

export const MagniteScript = () => {
  const { locale } = useRouterExtend()
  if (locale !== LOCALE.Taiwan) return null
  return (
    <Script
      async
      src="https://micro.rubiconproject.com/prebid/dynamic/22534.js"
    />
  )
}
